const SortingOrder = {
    ASCENDING: 'asc',
    DESCENDING: 'desc',
};

export default SortingOrder;